import React, { memo } from 'react';

import AutocompleteCDS from '../../form/AutocompleteCDS';
import FormGeneratorFieldWrapperCDS from '../FormGeneratorFieldWrapperCDS';

const FormGeneratorAutocompleteCDS = props => {
  return <FormGeneratorFieldWrapperCDS FieldComponent={AutocompleteCDS} {...props} />;
};

FormGeneratorAutocompleteCDS.propTypes = {
  ...FormGeneratorFieldWrapperCDS.propTypes,
  ...AutocompleteCDS.propTypes,
};

export default memo(FormGeneratorAutocompleteCDS);
